import { render, staticRenderFns } from "./light-gallery.vue?vue&type=template&id=7577bc94&scoped=true"
import script from "./light-gallery.vue?vue&type=script&lang=js"
export * from "./light-gallery.vue?vue&type=script&lang=js"
import style0 from "./light-gallery.vue?vue&type=style&index=0&id=7577bc94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7577bc94",
  null
  
)

export default component.exports